/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const MergeErrorMessage = styled.div`
  margin-top: ${gridSize()}px;
  display: flex;

  > span:first-child {
    margin-right: ${gridSize() / 2}px;
  }
`;

export const InnerButtonText = styled.span<{ isDisabled?: boolean }>`
  ${props => (props.isDisabled ? 'visibility: hidden' : '')};
`;

export const TooltipContent = styled.div`
  width: ${gridSize() * 16}px;
  text-align: center;
`;

export const ModalFooter = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 22px 24px 24px;
`;
